import { combineReducers } from 'redux';

import liveCheckCachedTripReducerMap, {
    liveCheckCachedTripAction,
} from './actions/liveCheckCachedTrip';
import {
    liveCheckItineraryAction,
} from './actions/liveCheckItinerary';
import liveCheckTripReducerMap, {
    liveCheckTripAction,
} from './actions/liveCheckTrip';
import liveCheckReducerMap, {
    actions as liveCheckActions,
    selectors as liveCheckSelectors,
} from './appstate';
import { EXTERNAL_CONSTANTS as CONSTANTS } from './constants';
import NAMESPACE from './types';

const reducer = combineReducers({
    ...liveCheckReducerMap,
    ...liveCheckCachedTripReducerMap,
    ...liveCheckTripReducerMap,
});

export {
    CONSTANTS,
    liveCheckActions,
    liveCheckCachedTripAction,

    liveCheckItineraryAction,
    liveCheckSelectors,

    liveCheckTripAction,
};

export default {
    [NAMESPACE]: reducer,
};
